export default "/images/vendor/flag-icon-css/flags/1x1/gq.svg?6c7f20b675f0fa8025dc0f84f5e21dfb";